<template>
  <div
    class="login-container pull-height"
    @keyup.enter.native="handleLogin"
  >
    <div
      class="login-left animated fadeInLeft"
      style="width:60%;height:100%"
    >
      <img
        src="https://joinstech-public.oss-cn-shenzhen.aliyuncs.com/f1b03fac2f43303d756d8c9f824f3dd4"
        alt=""
        style="height:100%;"
      >
    </div>
    <div
      class="login-border  animated fadeInRight"
      style="width:40%"
    >
      <div class="login-main">
        <img
          src="/svg/logo.svg"
          alt=""
          class="login-card-logo"
        >
        <h4 class="login-title">登录商户运营平台</h4>
        <userLogin v-if="activeName==='user'"></userLogin>
        <codeLogin v-else-if="activeName==='code'"></codeLogin>
        <thirdLogin v-else-if="activeName==='third'"></thirdLogin>
      </div>
    </div>
  </div>
</template>
<script>
import userLogin from "./userlogin";
import codeLogin from "./codelogin";
import thirdLogin from "./thirdlogin";
import topColor from "../index/top/top-color";
import color from "@/mixins/color";
import { mapGetters } from "vuex";
import { validatenull } from "@/util/validate";
export default {
  name: "login",
  mixins: [color()],
  components: {
    topColor,
    userLogin,
    codeLogin,
    thirdLogin
  },
  data() {
    return {
      activeName: "user"
    };
  },
  watch: {
    $route() {
      const params = this.$route.query;
      this.socialForm.state = params.state;
      this.socialForm.code = params.code;
      if (!validatenull(this.socialForm.state)) {
        const loading = this.$loading({
          lock: true,
          text: `${
            this.socialForm.state === "WX" ? "微信" : "QQ"
          }登录中,请稍后。。。`,
          spinner: "el-icon-loading"
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      }
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["website"])
  },
  props: [],
  methods: {}
};
</script>

<style lang="scss">
// ============================================
// 品牌色（登录场景使用更深的品牌蓝，与项目 variables.scss 解耦）
// ============================================
$login-primary: #2B7EFF;
$login-primary-hover: #4d92ff;
$login-text: #1f2329;
$login-text-sub: #6b7785;
$login-border: #dcdfe6;

// ============================================
// 容器与背景（原版布局保持不变，仅保留 ::before 背景图）
// ============================================
.login-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
}
.login-container::before {
  z-index: -999;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url("/img/login.png");
  background-size: cover;
  background-position: center;
}
.login-left {
  position: relative;
}

// ============================================
// 登录卡片（jomoo 风格：白底 + 6px 圆角 + 轻阴影）
// ============================================
.login-border {
  flex: 1;
  box-sizing: border-box;
}
.login-main {
  margin: 0 auto;
  width: 510px;
  padding: 36px 40px 32px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 6px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  animation: loginCardIn 0.5s cubic-bezier(0.2, 0, 0, 1) both;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
}
@keyframes loginCardIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.login-card-logo {
  display: block;
  margin: 0 auto 8px;
  height: 90px;
}
.login-title {
  margin: -15px 0 28px;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 2px;
  color: $login-primary;
}

// ============================================
// 表单输入（jomoo 风格：底边线 + 蓝色图标）
// ============================================
.login-form {
  margin: 0;
  width: 100%;

  i {
    color: $login-primary;
  }
  .el-form-item__content {
    width: 100%;
    line-height: 40px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-input {
    input {
      height: 40px;
      line-height: 40px;
      padding: 0 12px 0 38px;
      background: transparent;
      border: none;
      border-bottom: 1px solid $login-border;
      border-radius: 0;
      color: $login-text;
      font-size: 14px;
      transition: border-color 0.2s ease;
    }
    input::placeholder {
      color: #a8b1c1;
    }
    input:focus {
      border-bottom-color: $login-primary;
      outline: none;
    }
    .el-input__prefix {
      width: 38px;
      height: 40px;
      line-height: 40px;
      left: 0;
      text-align: center;
      i {
        padding: 0;
        font-size: 18px !important;
        line-height: 40px;
        color: $login-primary;
      }
    }
    .el-input__suffix {
      height: 40px;
      line-height: 40px;
      right: 6px;
    }
    .el-input__suffix .el-input__icon {
      line-height: 40px;
    }
    .el-input__icon {
      width: 28px;
    }
  }
}

// 记住账号 / 忘记密码 行
.login-form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 2px 18px;
  font-size: 13px;
  .el-checkbox {
    color: $login-text-sub;
    .el-checkbox__label {
      font-size: 13px;
      padding-left: 6px;
    }
  }
  .forgot-link {
    color: $login-primary;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }
  .forgot-link:hover {
    opacity: 0.75;
  }
}

// ============================================
// 登录按钮（jomoo 风格：矩形宽 100%，蓝色实心）
// ============================================
.login-submit {
  display: block;
  width: 100%;
  height: 40px;
  font-size: 15px;
  letter-spacing: 4px;
  border-radius: 4px;
  background: $login-primary !important;
  border: none !important;
  color: #fff !important;
  padding: 0;
  margin-top: 4px;
  transition: background 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba(43, 126, 255, 0.2);
}
.login-submit:hover {
  background: $login-primary-hover !important;
  box-shadow: 0 6px 16px rgba(43, 126, 255, 0.28);
}

// 底部"还没账号？立即申请入驻"链接
.login-register {
  margin-top: 18px;
  text-align: center;
  font-size: 13px;
  color: $login-text-sub;
  a {
    color: $login-primary;
    cursor: pointer;
    margin-left: 4px;
    transition: opacity 0.2s ease;
  }
  a:hover {
    opacity: 0.75;
  }
}

// ============================================
// 验证码区
// ============================================
.login-code {
  display: flex;
  align-items: center;
  height: 40px;
  margin: 0 0 0 10px;
}
.login-code-img {
  width: 100%;
  height: 40px;
  background: #fff;
  border: 1px solid $login-border;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease;
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 4px;
  color: $login-text;
}
.login-code-img:hover {
  border-color: $login-primary;
}

// ============================================
// 兼容旧用法（避免其他登录方式复用旧类名失效）
// ============================================
.login-menu {
  width: 100%;
  text-align: center;
  a {
    color: rgb(153, 153, 153);
    font-size: 12px;
    margin: 0px 8px;
  }
}
.login-index {
  margin-top: 40px;
  width: 180px;
  height: 48px;
  text-align: center;
  border-radius: 50px;
  background: transparent;
  color: #333;
  font-size: 16px;
  border: 1px solid rgb(152, 22, 244);
}
.ruzhu {
  font-size: 14px;
  color: gainsboro;
}

// ============================================
// 移动端适配
// ============================================
@media screen and (max-width: 767px) {
  .login-container {
    flex-direction: column;
  }
  .login-left {
    display: none !important;
  }
  .login-border {
    width: 100% !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .login-main {
    width: 90% !important;
    max-width: 440px;
    padding: 28px 24px 24px;
  }
  .login-title {
    font-size: 18px;
    margin-bottom: 22px;
    letter-spacing: 1px;
  }
  .login-card-logo {
    height: 90px;
  }
}
</style>